export const REQUEST_FETCH_COLLECTIONS_EM = "REQUEST_FETCH_COLLECTIONS_EM"
export const FETCH_COLLECTIONS_EM_SUCCESS = "FETCH_COLLECTIONS_EM_SUCCESS"
export const FETCH_COLLECTIONS_EM_FAILURE = "FETCH_COLLECTIONS_EM_FAILURE"

export const CLEAR_FETCH_COLLECTIONS_EM_STATES = "CLEAR_FETCH_COLLECTIONS_EM_STATES"